import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import * as programAction from "../../../../redux/actions/program.action";
import List from "../../../list/list";
import { fetchSASToken } from "../../../../services/SASTokenService";
import { formatDate } from "../../../../helpers/date";
import { useTranslation } from "react-i18next";
import placeholder from "../../../../assets/images/placeholder.jpg";
import PortalVisibilitySelect from "../../../PortalVisibilitySelect/PortalVisibilitySelect";

const programFields = [
  //list will sort by the first element by default
  "name",
  "title",
  "order"
];

const ProgramList = ({ type }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [token, setToken] = useState(null);
  const [updatedPrograms, setUpdatedPrograms] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const { programs, meta, listLoading, error } = useSelector((state) => ({
    programs: state.program.programList,
    meta: state.program.programMetadata,
    listLoading: state.program.listLoading,
    error: state.program.error,
  }));

  useEffect(() => {
    programAction.fetchAll(dispatch, type);
    const fetchToken = async () => {
      const newToken = await fetchSASToken();
      setToken(newToken);
    };
    fetchToken();
  }, [dispatch, type]);

  const handleVisibilityChange = (programId) => async (selectedOption) => {
    try {
      const updateData = {
        data: {
          visibility: selectedOption.value
        }
      };
      await programAction.update(dispatch, programId, updateData);
      setAlertMessage(`Program visibility updated to: ${selectedOption.label}`);
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      // Refresh the list to reflect the change
      programAction.fetchAll(dispatch, type);
    } catch (error) {
      setErrorMessage('Failed to update program visibility');
      setTimeout(() => setErrorMessage(''), 5000);
    }
  };

  useEffect(() => {
    if (programs?.data && programs?.data?.length > 0 && token) {
      setUpdatedPrograms(
        programs?.data?.map(
          ({ id, attributes: { image, name, title, createdAt, order, tooltip, visibility } }) => {
            const columns = [
              { primary: name, secondary: title},
              {primary: title},
              {
                primary: (
                  <PortalVisibilitySelect
                    value={visibility}
                    onChange={handleVisibilityChange(id)}
                    compact={true}
                  />
                )
              }
            ];
            return {
              id,
              image: image?.data ? `${image?.data?.attributes?.url}?${token}` : placeholder,
              columns,
              name,
              order,
              title,
            }
          }
        )
      );
    }
  }, [programs, token, dispatch, type]);

  const columnsNames = ["","IMAGE", "NAME", "TITLE", "Visibility"];

  return (
    <List
      tooltipTextDelete="Delete Program"
      title={t("programs.programs")}
      redirect={`/${type.toLowerCase()}programs/form`}
      columnNames={columnsNames}
      hasImage={true}
      entities={updatedPrograms}
      fieldsToSort={programFields}
      fetchAction={(params) => programAction.fetchAll(dispatch, type, params)}
      isOverview={false}
      metadata={meta}
      showFilterTab={false}
      deleteAction={(id, params) => programAction.remove(dispatch, id, params, type)}
      loading={listLoading}
      sortIsDisabled={false}
      reOrderAction={(body, filterParams) =>{programAction.reOrder({ dispatch, body, filterParams, type }) }}
      showAlert={showAlert}
      successAlertMessage={alertMessage}
      setShowAlert={setShowAlert}
      customListError={errorMessage}
    />
  );
};

export default ProgramList;
